import React, { useState } from "react";
import { Wrapper, Drawer } from "@/components";
import styles from "./style.less";
import { LeftIcon, CloseIcon } from "../icon";
import { i18n } from "@/utils";
import { IDoubleIncrement } from "../increment";
import classNames from "classnames";

interface IDoubleProps {
  /**
   * @description 二份数据
   */
  data: IDoubleIncrement;
  /**
   * @description 关闭回调
   * @
   */
  onClose?: () => void;
  /**
   * @description 确认回调
   */
  onConfirm?: (newDesign?: boolean) => void;
}

const Double: React.FC<IDoubleProps> = ({ data, onClose, onConfirm }) => {
  /** 弹层 */
  const [designVisible, setDesignVisible] = useState(false);

  /** 关闭 */
  const handleClose = () => {
    if (designVisible) {
      setDesignVisible(false);
      return;
    }
    onClose?.();
  };

  return (
    <>
      <Wrapper className={styles.double}>
        <Drawer mask onClose={handleClose} className={styles.doubleDrawer}>
          <div className={styles.doubleHeader}>
            <div className={styles.doubleHeaderIcon} onClick={handleClose}>
              <CloseIcon />
            </div>
          </div>
          <div className={styles.doubleContent}>
            <div
              className={classNames(styles.button, styles.active, styles.small)}
              dangerouslySetInnerHTML={{
                __html: `
                  <div>${i18n.format("increment.double.title",`<span style="font-size: 24px">${data.discount}</span>`)}</div>
                  <div>${i18n.format("increment.double.save.now")}</div>
                `
              }}
              onClick={() => setDesignVisible(true)}
            ></div>
            <div className={styles.line}>
              <span>{i18n.format("increment.or")}</span>
            </div>
            <div
              className={classNames(styles.button, styles.weight, styles.small)}
              onClick={() => onConfirm?.()}
            >
              {i18n.format("increment.no.thanks")}
            </div>
          </div>
        </Drawer>
      </Wrapper>
      {designVisible && (
        <Wrapper className={styles.double}>
          <Drawer mask onClose={handleClose} className={styles.doubleDrawer}>
            <div className={styles.doubleHeader}>
              <div className={styles.doubleHeaderIcon} onClick={handleClose}>
                <LeftIcon />
              </div>
            </div>
            <div className={styles.doubleContent}>
              <div
                className={classNames(styles.button, styles.active)}
                onClick={() => onConfirm?.(false)}
              >
                {i18n.format("increment.double.same")}
              </div>
              <div className={styles.line}>
                <span>{i18n.format("increment.or")}</span>
              </div>
              <div
                className={classNames(styles.button)}
                onClick={() => onConfirm?.(true)}
              >
                {i18n.format("increment.double.new")}
              </div>
            </div>
          </Drawer>
        </Wrapper>
      )}
    </>
  );
};

export default Double;
